import React, { useEffect, useId, useRef, useState } from 'react';
import { FAVORITE_MODE_COPY } from '../../utils/favorites';
import './FavoriteModeHelp.css';

export default function FavoriteModeHelp({ className = '' }) {
  const [open, setOpen] = useState(false);
  const popoverRef = useRef(null);
  const rootRef = useRef(null);
  const tooltipId = useId();

  useEffect(() => {
    if (!open) return undefined;
    popoverRef.current?.focus();

    function handlePointerDown(event) {
      if (rootRef.current?.contains(event.target)) return;
      setOpen(false);
    }

    function handleKeyDown(event) {
      if (event.key === 'Escape') setOpen(false);
    }

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('touchstart', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('touchstart', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  return (
    <div ref={rootRef} className={`favorite-mode-help ${className}`.trim()}>
      <button
        type="button"
        className="favorite-mode-help__trigger"
        aria-label="How favorites work"
        aria-expanded={open}
        aria-controls={tooltipId}
        onClick={() => setOpen((v) => !v)}
      >
        ?
      </button>
      {open && (
        <div
          id={tooltipId}
          ref={popoverRef}
          className="favorite-mode-help__popover"
          role="dialog"
          aria-label="How favorites work"
          tabIndex={-1}
        >
          <strong>How favorites work</strong>
          <p><strong>Best guess:</strong> {FAVORITE_MODE_COPY[''].tooltip}</p>
          <p><strong>Brand / chain:</strong> {FAVORITE_MODE_COPY.brand.tooltip}</p>
          <p><strong>Broad:</strong> {FAVORITE_MODE_COPY.broad.tooltip}</p>
        </div>
      )}
    </div>
  );
}
